import React from 'react';
import { motion } from 'framer-motion';
import { MapPinIcon, ArrowRightIcon, MessageCircleIcon } from 'lucide-react';
import { CONTACT, PROMO } from '../data/site';
export function Hero() {
  return <section id="home" className="relative w-full overflow-hidden bg-ink pt-16 sm:pt-20" data-id="element-113" data-mp="9k0fha3kwjqp">
      <div className="absolute inset-0" data-id="element-114" data-mp="4m8mecr76rkx">
        <img src={CONTACT.hero} alt="Coach striking a ball during a Leal 11 Sports training session at Juniper Valley Park" className="h-full w-full object-cover object-right sm:object-center" loading="eager" data-id="element-115" data-mp="4n9wadwh9812" />
        {/* Mobile: stronger vertical scrim so white copy stays readable over the coach */}
        <div className="absolute inset-0 bg-gradient-to-b from-black/85 via-black/70 to-black/90 sm:hidden" data-id="element-116" data-mp="ncq13df73mna" />
        <div className="absolute inset-0 hidden sm:block bg-gradient-to-t from-black via-black/80 to-black/40" data-id="element-117" data-mp="3d1sdb54ebxwt" />
        <div className="absolute inset-0 hidden sm:block bg-gradient-to-r from-black/85 via-black/40 to-transparent" data-id="element-118" data-mp="381e1rd3l65u1" />
      </div>

      <div className="relative mx-auto max-w-7xl px-4 sm:px-6 py-10 sm:py-24 lg:py-32" data-id="element-119" data-mp="3j9afx9oryk3k">
        <div className="max-w-2xl" data-id="element-120" data-mp="3o73p8bldju82">
          <motion.span initial={{
          opacity: 0,
          y: 12
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5
        }} className="inline-flex items-center gap-2 rounded-full border border-brand-orange/40 bg-brand-orange/10 px-4 py-1.5 text-[11px] font-bold uppercase tracking-[0.18em] text-brand-orange" data-id="element-121" data-mp="39acwgl67hgrf">
            {PROMO}
          </motion.span>

          <motion.h1 initial={{
          opacity: 0,
          y: 16
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.08
        }} className="mt-4 text-[2rem] leading-[1.05] uppercase sm:mt-5 sm:text-5xl lg:text-6xl" data-id="element-122" data-mp="2qk3k4igpg8m0">
            Build Your Future on the Pitch:{' '}
            <span className="bg-gradient-to-r from-brand-orange to-brand-red bg-clip-text text-transparent" data-id="element-123" data-mp="2ll0ht5s40ghq">
              Elite Soccer Training in NYC
            </span>
          </motion.h1>

          <motion.p initial={{
          opacity: 0,
          y: 16
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.16
        }} className="mt-3 max-w-xl text-sm sm:mt-5 sm:text-lg text-white/80" data-id="element-124" data-mp="nb1kl4ct1rwf">
            Professional coaching at Juniper Valley Park for kids and teens. Join the academy led by
            FIFA Registered Coach Leonard Leal.
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          y: 16
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.24
        }} className="mt-6 flex flex-col gap-3 sm:mt-8 sm:flex-row sm:items-center" data-id="element-125" data-mp="163436l90bi9b">
            <a href="#register" className="inline-flex items-center justify-center gap-2 rounded-full bg-gradient-to-r from-brand-orange to-brand-red px-7 py-4 text-sm font-bold uppercase tracking-wide text-white shadow-xl shadow-brand-red/30 transition-transform hover:scale-[1.03]" data-id="element-126" data-mp="3ltgmlp4rwont">
              Claim 20% Discount Now
              <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-127" data-mp="218tq5wogtcfe" />
            </a>
            <a href={CONTACT.whatsapp} target="_blank" rel="noreferrer" className="inline-flex items-center justify-center gap-2 rounded-full border border-white/25 bg-white/5 px-7 py-4 text-sm font-semibold text-white backdrop-blur transition-colors hover:bg-white/10" data-id="element-128" data-mp="268ognz4bvzzx">
              <MessageCircleIcon className="h-4 w-4" aria-hidden="true" data-id="element-129" data-mp="2p0qpwpen4e05" />
              Message us on WhatsApp
            </a>
          </motion.div>

          <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          duration: 0.5,
          delay: 0.32
        }} className="mt-6 flex flex-wrap items-center gap-x-6 gap-y-2 text-xs sm:mt-8 sm:text-sm text-white/60" data-id="element-130" data-mp="2tz1zr04xqoid">
            <span className="inline-flex items-center gap-2" data-id="element-131" data-mp="4acohj4ke1al">
              <MapPinIcon className="h-4 w-4 text-brand-orange" aria-hidden="true" data-id="element-132" data-mp="3vhxijq1klk1p" />
              {CONTACT.field}
            </span>
            <span data-id="element-133" data-mp="e8iofv6t8xct">Ages 5–17 · Beginner to Advanced</span>
          </motion.div>
        </div>
      </div>
    </section>;
}